import React, {Component} from "react";
import PropTypes from "prop-types";
import Icofont from 'react-icofont';
import ScrollAnimation from 'react-animate-on-scroll';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet';

const position = [46.769604, 23.546521];

class Contact extends Component {
  render() {
    return (
      <React.Fragment>
        <section id="contact" className="contact-area ptb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 offset-lg-2 text-center">
                <ScrollAnimation animateIn="fadeInUp">
                  <div className="section-title">
                    <h2>{this.props.sectionTitle}</h2>
                    <span
                      className="section-title-bg">{this.props.SectionbgTitle}</span>
                  </div>
                </ScrollAnimation>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-4">
                <div className="address-area">
                  <div className="addess">
                    <Icofont icon="icofont-google-map"/>
                    <h4>{this.props.AddTitle}</h4>
                    <p>{this.props.Address}</p>
                  </div>
                  <div className="email">
                    <Icofont icon="icofont-email"/>
                    <h4>{this.props.EmailTitle}</h4>
                    <p>{this.props.Email}</p>
                  </div>
                  <div className="phone">
                    <Icofont icon="icofont-phone"/>
                    <h4>{this.props.PhoneTitle}</h4>
                    <p>{this.props.Phone}</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-8 col-md-8">
                <div className="contact-map">
                  <link rel="stylesheet"
                        href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
                        integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
                        crossOrigin=""/>
                  <Map
                    center={position}
                    zoom={16}
                    maxZoom={20}
                    zoomControl={false}
                    pane="markerPane"
                    linkStyle={true}
                    prefereCanvas={true}
                    scrollWheelZoom={true}>
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                    />
                    <Marker position={position}>
                      <Popup><strong>Casa Maria</strong><br />Casa Maria.</Popup>
                    </Marker>
                  </Map>
                </div>
              </div>

            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

//Props Types
Contact.propTypes = {
  SectionbgTitle: PropTypes.string,
  sectionTitle: PropTypes.string,
  AddTitle: PropTypes.string,
  Address: PropTypes.string,
  EmailTitle: PropTypes.string,
  Email: PropTypes.string,
  PhoneTitle: PropTypes.string,
  Phone: PropTypes.string,
};

//Default Props
Contact.defaultProps = {
  SectionbgTitle: "Contact",
  sectionTitle: "Contacteaza-ne",
  AddTitle: "Address",
  Address: "Strada Donath nr. 150E",
  EmailTitle: "Email",
  Email: "casamaria.cj@gmail.com",
  PhoneTitle: "Telefon",
  Phone: "+40 751 354 693",
};
export default Contact;
